import { render, staticRenderFns } from "./WidgetCode.vue?vue&type=template&id=64c4a94c"
import script from "./WidgetCode.vue?vue&type=script&lang=js"
export * from "./WidgetCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c4a94c')) {
      api.createRecord('64c4a94c', component.options)
    } else {
      api.reload('64c4a94c', component.options)
    }
    module.hot.accept("./WidgetCode.vue?vue&type=template&id=64c4a94c", function () {
      api.rerender('64c4a94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget-code/WidgetCode.vue"
export default component.exports